<template>
  <div class="donut-chart">
    <BaseText5 :text="label"/>
    <BaseText3 :text="value"/>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.54403 52.54403">
      <path fill="none" stroke="var(--color-gray-2)" stroke-width="14" d="M26.272,7A19.272,19.272,0,1,1,7,26.272,19.272,19.272,0,0,1,26.272,7"/>
      <path ref="ring" fill="none" stroke="#fff" stroke-width="14" d="M26.272,7A19.272,19.272,0,1,1,7,26.272,19.272,19.272,0,0,1,26.272,7"/>
    </svg>
  </div>
</template>

<script>
import { TweenMax } from 'gsap'
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText5 from '@/components/BaseText5/BaseText5'
import '@/assets/lib/DrawSVGPlugin'
export default {
  components: {
    BaseText3,
    BaseText5
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    ratio: {
      type: Number,
      required: true
    }
  },
  mounted () {
    TweenMax.set(this.$refs['ring'], { drawSVG: this.ratio * 100 + '%' })
  }
}
</script>

<style lang="scss" scoped>
.donut-chart {
  width: 100%;
}
svg {
  display: block;
  will-change: transform;
  margin: 0.3rem 0 0 0;
}
</style>
